import { atom as t } from "jotai";
import { atomWithDefault as o } from "jotai/utils";
const a = t(!1), s = o(
  (e) => e(a)
), A = t(""), d = t(
  (e) => e(s)
), f = t(
  null,
  (e, n, c) => {
    n(s, c);
  }
), m = t(!1), l = o(
  (e) => e(m)
), i = t(
  (e) => e(l)
), I = t(
  null,
  (e, n, c) => {
    n(l, c);
  }
);
export {
  i as getInsuranceSelectedAtom,
  d as getSelectedInsuranceAtom,
  A as insurancePriceAtom,
  l as insuranceSelectedAtom,
  m as insuranceSelectedAtomDefault,
  s as selectedInsuranceAtom,
  a as selectedInsuranceAtomDefault,
  I as setInsuranceSelectedAtom,
  f as setSelectedInsuranceAtom
};
